import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import productCard from '../snippets/product-card';
export const initCategoryTabScript = () => {
  const tabButtons = document.querySelectorAll('.catagory__tab-button');
  const tabContents = document.querySelectorAll('.catagory__tab-content');
  if (!tabButtons || !tabContents) return;
  const swiperButton = document.querySelector('.catagory__swiperBtn');
  const prevButton = swiperButton?.querySelector(
    '.catagory__swiper-btn-prev.swiper-btn-prev',
  );
  const nextButton = swiperButton?.querySelector(
    '.catagory__swiper-btn-next.swiper-btn-next',
  );
  let isLargeScreen = window.matchMedia('(min-width: 1024px)').matches;

  function showTabContent(selectedTabId) {
    tabContents.forEach((content) => {
      if (content.dataset.tabContent === selectedTabId) {
        content.classList.remove('hidden');

        const swiperWrapper = content.querySelector('.swiper-wrapper');
        const slideCount = swiperWrapper ? swiperWrapper.children.length : 0;

        productCard.initialiseEvents(`[data-tab-content="${selectedTabId}"]`);

        // handling the default swiper button styling for tab switching to show or hide the buttons
        if (slideCount > 4 && isLargeScreen) {
          swiperButton?.classList.remove('hidden');
          swiperButton?.classList.add('lg:flex');

          [prevButton, nextButton].forEach((button) => {
            button?.classList.add('!block');
            button?.removeAttribute('disabled');
          });
          swiperButton.parentElement.classList.remove('show-padding');

          nextButton?.setAttribute('tabindex', '0');
          nextButton?.classList.remove('pointer-events-none', 'opacity-50');

          return;
        }
        swiperButton?.classList.add('hidden');
        swiperButton?.classList.remove('lg:flex');

        [prevButton, nextButton].forEach((button) => {
          button?.classList.add('hidden');
          button?.setAttribute('disabled', true);
        });
        swiperButton.parentElement.classList.add('show-padding');

        return;
      }
      content.classList.add('hidden');
    });

    tabButtons?.forEach((button) => {
      if (button.dataset.tab === selectedTabId) {
        button.classList.add('is-selected');
      } else {
        button.classList.remove('is-selected');
      }
    });
  }

  if (tabButtons.length > 1) {
    tabButtons?.forEach((button) => {
      button.addEventListener('click', function () {
        const selectedTabId = this.dataset.tab;
        showTabContent(selectedTabId);
      });
    });
    const firstTabId = tabButtons[0].dataset.tab;
    showTabContent(firstTabId);

    window.addEventListener('resize', () => {
      const currentIsLargeScreen = window.matchMedia(
        '(min-width: 1024px)',
      ).matches;
      if (currentIsLargeScreen !== isLargeScreen) {
        isLargeScreen = currentIsLargeScreen;
        showTabContent(firstTabId);
      }
    });
  }
  const categorySwiperContainers = document.querySelectorAll(
    '.catagory__swiper-container',
  );
  if (categorySwiperContainers.length == 0) return;
  categorySwiperContainers.forEach((container) => {
    new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      loop: false,
      navigation: {
        nextEl: '.catagory__swiperBtn .swiper-btn-next',
        prevEl: '.catagory__swiperBtn .swiper-btn-prev',
        disabledClass: 'pointer-events-none opacity-50',
      },
      watchOverflow: true,
      breakpoints: {
        375: {
          slidesPerView: 1.32,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2.3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2.6,
          spaceBetween: 24,
        },
        1536: {
          slidesPerView: 4.18,
          spaceBetween: 32,
        },
      },
    });
  });
};
